import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material';
import { RedireccionMenu } from '../../../../models/menu/redireccion-menu.class';
import { RedireccionService } from '../../../../services/redireccion/redireccion.service';


@Component({
  selector: 'app-asesoria-y-venta-cliente-dialog',
  templateUrl: './asesoria-y-venta-cliente-dialog.component.html'
})
export class AsesoriaYVentaClienteDialogComponent implements OnInit {

  constructor(private route: Router,
    @Inject(MAT_DIALOG_DATA) public redireccionMenu: RedireccionMenu,
    private redireccionService: RedireccionService) { }

  ngOnInit() {
  }

  cargarNuevoProcesoAsesoriaVenta() {
    this.redireccionService.redireccionAYVEstatica(this.redireccionMenu.filtroBuscarCliente.datosCliente.tipoDocumento.toString()
      , this.redireccionMenu.filtroBuscarCliente.datosCliente.numeroDocumento.toString());

  }

  continuarFormularioCliente() {
    if (this.redireccionService.optionMenuRedireccionGWT(this.redireccionMenu.opcionVenta)) {
      this.redireccionService.redireccionProductoGWT(this.redireccionMenu.filtroBuscarCliente.datosCliente.tipoDocumento.toString(),
        this.redireccionMenu.filtroBuscarCliente.datosCliente.numeroDocumento.toString());
    } else {
      this.route.navigate(['Clientes']);
    }

  }
}




// WEBPACK FOOTER //
// ./src/app/components/cliente/dialogs/asesoria-y-venta-cliente-dialog/asesoria-y-venta-cliente-dialog.component.ts